var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",class:{hidden: !_vm.display_on_mobile},attrs:{"poster":_vm.poster_src,"preload":_vm.preload,"autoplay":_vm.autoplay,"loop":_vm.loop},domProps:{"muted":_vm.muted}},[_c('source',{attrs:{"data-src":_vm.source,"src":_vm.src,"type":_vm.type}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a59c85b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Video.vue
// module id = bGsN
// module chunks = 0 1